import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuContent from './MenuContent';
import { useContext } from 'react';
import { AuthContext } from '../utils/AuthContext';
import Global from '../utils/Global';


export default function SideMenuMobile({ open, setOpen, toggleDrawer, currentPage, setOpenLogoutDialog }) {
  const { auth, setAuth } = useContext(AuthContext);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: 99998,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1, minWidth: 190 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={auth.user.full_name}
              src={Global.storageURL + auth.user.image}
            />
            <Typography component="p" variant="h6">
              {auth.user.full_name}
            </Typography>
          </Stack>
          {/* <MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton> */}
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent
            setOpen={setOpen}
            sx={{ marginX: 1 }}
            currentPage={currentPage}
            setOpenLogoutDialog={setOpenLogoutDialog} />
          <Divider />
        </Stack>
      </Stack>
    </Drawer>
  );
}
